import './testScreen.scss';
import React from 'react';

const TestScreen: React.FC = () => {



    return (
        <div className="flex items-center justify-center h-screen bg-gray-200">
            {/*<button className="p-4 bg-red-500 text-white rounded-lg" onClick={prevImage}>*/}
            {/*    Prev*/}
            {/*</button>*/}
            {/*<img key={activeIndex} className="w-3/4 h-3/4 rounded-lg object-cover transition-all duration-500 ease-in-out" src={images[activeIndex]} alt="carousel" />*/}
            {/*<button className="p-4 bg-green-500 text-white rounded-lg" onClick={nextImage}>*/}
            {/*    Next*/}
            {/*</button>*/}
        </div>
    );
};

export default TestScreen;

